module.exports = "/assets/kinley-page/hero@2x.jpg?VPmXX7y";